import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { IPEN_ENHANCED } from '../constants';
import { rewriteUrl } from '../utils/rewriteUrl';

/**
 * Creates a link updater function that will update the links in the iframe
 */
export const useAnchorRewriter = () => {
  const nav = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  return useCallback(
    (a: HTMLAnchorElement) => {
      const href = a.getAttribute('href');
      if (!href) {
        return;
      }

      // rewrite relative links so they can be used outside the iframe to navigate the React-App
      const newHref = rewriteUrl(href, currentPath);
      if (href !== newHref) {
        a.setAttribute('href', newHref);
        a.setAttribute(IPEN_ENHANCED, 'true');
        a.addEventListener('click', me => {
          void nav(newHref);
          me.preventDefault();
        });
      }

      // open all links in the parent window
      if (!a.getAttribute('target')) {
        a.setAttribute('target', '_parent');
      }
    },
    [nav, currentPath],
  );
};
